import { useMutation } from '@tanstack/react-query';
import { useAxios } from 'shared/hooks';

export const useNoClaimConsent = (id?: string) => {
  const { post } = useAxios();

  return useMutation<void, Error>(
    async () => await post<void, void>(`/api/v2/policyapplications/${id}/noclaimconsent`)
  );
};
